var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('b-row',{},[_c('b-col',{staticClass:"address",attrs:{"md":"12","cols":"12"}},[_c('div',{},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.privacy.content.rendered )}})])])],1)],1),_c('div',[_c('Footer',{attrs:{"config":_vm.config,"white":_vm.white}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }